import { getUserInfo, getUserPermission } from '@/api/user/user';

const initialState = {
  email: '',
  phone: '',
  openid: '',
  full_name: '',
  user_type: '',
  company: '',
  menuList: [],
  btnList: [],
  userId: '',
};
export default {
  namespaced: true,
  state: {
    ...initialState,
  },
  mutations: {
    updateState(state, payload) {
      Object.assign(state, payload);
    },
    clearState(state) {
      Object.assign(state, {
        ...initialState,
      });
    },
  },
  actions: {
    async getUserInfo({ commit }) {
      const res = await getUserInfo();
      if (res) {
        commit('updateState', {
          ...res,
          userId: res.id,
        });
      }
    },
    async getUserPermission({ commit, state }) {
      const res = await getUserPermission();
      if (res) {
        commit('updateState', {
          menuList: res.filter((item) => item.resource_type === 'MENU').map((item) => item.resource_name),
          btnList: res.filter((item) => item.resource_type === 'UI').map((item) => item.resource_name),
        });
        return !!res.length;
      }
      return false;
    },
  },
};
